import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess Don Cheadle in 6 tries. After each guess, the color of the tiles will
        change to show how close your guess was to the word.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="C"
          status="correct"
        />
        <Cell value="O" />
        <Cell value="N" />
        <Cell value="N" />
        <Cell value="O" />
        <Cell value="R" />
        <Cell value="S" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter C is in Cheadle and in the correct spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="P" />
        <Cell value="O" />
        <Cell value="I" />
        <Cell value="T" />
        <Cell value="I" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="E"
          status="present"
        />        
        <Cell value="R" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter E is in Cheadle but in the wrong spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="U" />
        <Cell value="S" />
        <Cell isRevealing={true} isCompleted={true} value="T" status="absent" />
        <Cell value="I" />
        <Cell value="N" />    
        <Cell value="O" />
        <Cell value="V" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter T is not in Cheadle in any spot.
      </p>
    </BaseModal>
  )
}
